// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CreateProjectContainer_wrap__1on_M","title":"CreateProjectContainer_title__1X6bs"};